export default __webpack_public_path__ + "static/media/welcome.87b0086e.png";